
<template>
  <div>
    <el-dialog class="bg" title="设置主题颜色" :visible.sync="visible" width="30%" :before-close="handleClose"
      :close-on-click-modal="false">

      <div class="testTheme">
        <div></div>
      </div>
      <div class="buttons">
        <button @click="handlerClick('default')">默认主题</button>
        <button @click="handlerClick('blue')">蓝色</button>
        <button @click="handlerClick('green')">绿色</button>
        <button @click="handlerClick('grey')">灰色</button>
        <button @click="handlerClick('yellow')">黄色</button>
        <button @click="handlerClick('red')">红色</button>
        <div class="zdyzt">
          <el-color-picker v-model="color1" @change="custom">自定义</el-color-picker>
          <span>自定义</span>
      
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { setTheme } from '@/assets/css/theme'
export default {
  name: "myTheme",
  data() {
    return {
      visible: false,
      color1: '#304156'
    }
  },
  created() {

  },
  mounted() {

    this.init()
  },
  methods: {
    open() {
      this.visible = true
    },
    handleClose() {
      this.visible = false
    },
    init() {
      //初始主题，需要先判断本地有没有用户存储的主题，如果有，就使用用户存储的主题，如果没有，就初始化默认主题
      const theme = localStorage.getItem('primaryColor')
      if (theme) {
        this.color1 = theme
        setTheme()
        return;
      }
      setTheme('default') // 初始化未默认主题
    },
    //设置主题
    handlerClick(value){
      setTheme(value)
    },

    // 自定义主题
    custom() {
      //console.log('自定义主题')
      const newColor = {
        r: 12,
        g: 33,
        b: 234
      }
      const newPrimaryColor = this.color1//`rgb(${newColor.r},${newColor.g},${newColor.b})`
      localStorage.setItem('primaryColor', newPrimaryColor) // 将新的主题色存入本地
      setTheme()
    }

  }
}
</script>
<style lang="less" scoped>
.testTheme {
  display: flex;
  justify-content: center;
  align-content: center;
  margin-bottom: 20px;
  width: 100%;

}

.testTheme>div {
  width: 200px;
  height: 40px;
  background: @primaryColor;
  color: @primaryTextColor;
  border-radius: 5px;
}
.buttons{
display: flex;
flex-direction: row;
justify-content: space-around;
align-content: center;
}
.buttons>button{
cursor: pointer;
border: 0px solid #304156;
max-width: 80px;
max-height: 50px;
border-radius: 10%;
margin-right: 10px;
}
.buttons>button:nth-of-type(1){
background-color: #304156;
color: #fff;
}
.buttons>button:nth-of-type(2){
background-color: #66b1ff;
color: #fff;
}
.buttons>button:nth-of-type(3){
background-color: #85ce61;
color: #fff;
}
.buttons>button:nth-of-type(4){
background-color: #a6a9ad;
color: #fff;
}
.buttons>button:nth-of-type(5){
background-color: #ebb563;
color: #fff;
}
.buttons>button:nth-of-type(6){
background-color: #f78989;
color: #fff;
}
.zdyzt{
display: flex;
flex-direction: column;
justify-content: center;
align-content: center;
}
/deep/.el-dialog__title{
font-size: 30px;
font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// src/components/myTheme/myTheme.vue